import React, { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { Colors } from "../../../../helpers/Colors";
import { fontSize } from "../../../../helpers/fontSize";
import axios from "axios";
import { DatePicker } from "@material-ui/pickers";
import { BsCalendarEvent } from "react-icons/bs";
import { BiTime } from "react-icons/bi";
import lime from "@material-ui/core/colors/lime";
import { TimePicker } from "@material-ui/pickers";
import { format } from "date-fns";
import toast from "react-hot-toast";
import { ax_getCabins } from "../../../../api/cabin";
import { ax_updateBooking } from "../../../../api/reservation";

const useStyles = makeStyles({
  Page: {
    "& .MuiFormControl-root, .MuiTextField-root": {
      display: "none !important",
    },
    "& .MuiInputBase-input, .MuiInput-input": {
      display: "none !important",
    },
    "& ..MuiPickersToolbar-toolba": {
      backgroundColor: `${Colors.secondary} !important`,
    },
    //  padding: "20px 25px",
    width: "100%",
    backgroundColor: Colors.pageBg,
    overflow: "scroll",

    /* Hide scrollbar for Chrome, Safari and Opera */
    "&::-webkit-scrollbar": {
      display: "none",
    },
    "@media only screen and (max-Width: 770px) ": {
      // padding: "10px 15px",
    },
  },
  Page_Content: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  Input_Container: {
    backgroundColor: Colors.sidebarWhite,
    //  padding: "20px 30px",
    borderRadius: "10px",
    // overflow: "scroll",
    "@media only screen and (max-Width: 770px) ": {
      // padding: "10px 15px",
      // height: "550px",
    },
  },
  Container_Two: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "fit-content",
    "& .CabinName_Con": {
      display: "flex",
      flexDirection: "column",
      width: "280px",
      padding: "0px 30px 15px 0",
      "@media only screen and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "230px",
      },
      // "@media (min-Width: 770px) and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        //   "@media only screen and (max-Width: 770px) ": {
        //     fontSize: fontSize.label,
        //   },
      },
      "& select": {
        fontWeight: 500,
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.primaryExtraLight2,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {
          //  fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
        "& option": {
          maxHeight: "100px",
          overflowY: "scroll",
        },
      },
      "& ::placeholder": {},
    },
    "& .Day_Con": {
      display: "flex",
      flexDirection: "column",
      width: "250px",
      padding: "0px 0px 15px 0",
      // "@media only screen and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "@media only screen and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "200px",
      },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        //   "@media only screen and (max-Width: 770px) ": {
        //     fontSize: fontSize.label,
        //   },
      },
      "& select": {
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.inputBg,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.inputText,
        "@media only screen and (max-Width: 770px) ": {
          //  fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
        "& option": {
          maxHeight: "100px",
          overflowY: "scroll",
        },
      },
      "& ::placeholder": {},
    },
  },
  OrginalaDatePicker: {},
  datePicker: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: "10px",
    border: `2px solid ${Colors.inputBg}`,
    backgroundColor: Colors.primaryExtraLight2,
    borderRadius: "5px",
    "& .Calender_Con": {
      fontWeight: "bold",
      color: Colors.tableRowsText,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& .calenderIconCon": {
        //   border: `0px solid ${Colors.sidebarWhite}`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        "& .calenderIcon": {
          fontSize: "25px",
          padding: "0px",
          color: Colors.primary,
          //  backgroundColor: Colors.white,
        },
      },
    },
    "& .date_time_Con": {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      margin: "0px 0px 0px 5px",

      "& .date": {
        fontWeight: 500,
        fontSize: "16px",
        color: Colors.secondary,
        display: "flex",
        alignItems: "center",
        margin: "0 0 0 10px",
        // justifyContent: "flex-start",
        // margin: "0px 0px 0px 10px",
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
        },
      },
      "& .time": {
        margin: "0px 0px 0px 0px",
        fontWeight: 500,
        fontSize: "16px",
        color: Colors.textGrey,
        display: "flex",
        alignItems: "center",
        // justifyContent: "flex-start",
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
        },
      },
    },
    "& div": {
      "& .date": {
        fontSize: 16,
        color: Colors.grey,
      },
      "& .time": {
        fontSize: 14,
        color: Colors.grey,
      },
    },
  },
  Container_Three: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-evenly",
    width: "fit-content",
    "& .StartTime_Con": {
      display: "flex",
      flexDirection: "column",
      width: "280px",
      padding: "0px 30px 15px 0",
      // "@media only screen and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "@media only screen and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "230px",
      },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        //   "@media only screen and (max-Width: 770px) ": {
        //     fontSize: fontSize.label,
        //   },
      },
      "& select": {
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.inputBg,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.inputText,
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.label,
          padding: "6px 8px 8px 8px",
        },
      },
      "& ::placeholder": {},
    },
    "& .EndTime_Con": {
      display: "flex",
      flexDirection: "column",
      width: "250px",
      padding: "0px 0px 15px 0",
      // "@media only screen and (max-Width: 1100px) ": {
      //   width: "250px",
      // },
      "@media only screen and (max-Width: 770px) ": {
        display: "flex",
        flexDirection: "column",
        width: "200px",
        padding: "0px 0px 15px 0",
      },
      "& label": {
        fontSize: fontSize.modalInput,
        fontWeight: 500,
        color: Colors.secondary,
        //   "@media only screen and (max-Width: 770px) ": {
        //     fontSize: fontSize.Tablet_paragraph,
        //   },
      },
      "& select": {
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.inputBg}`,
        backgroundColor: Colors.inputBg,
        fontSize: fontSize.modalInput,
        borderRadius: "5px",
        color: Colors.inputText,
        "@media only screen and (max-Width: 770px) ": {
          fontSize: fontSize.Tablet_paragraph,
          padding: "6px 8px 8px 8px",
        },
      },
      "& ::placeholder": {},
    },
  },
  Container_Six: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "full",
    "& .Submit_Button": {
      width: "100%",
      fontWeight: 600,
      padding: "0px 0px 0px 0",
      "& button": {
        width: "100%",
        padding: "10px 10px",
        margin: "2px 0px 0 0 ",
        outline: "none",
        border: `2px solid ${Colors.primary}`,
        backgroundColor: Colors.primary,
        fontSize: "16px",
        borderRadius: "5px",
        color: Colors.secondary,
        "@media only screen and (max-Width: 770px) ": {},
      },
    },
  },
});

const Edit_Model = ({
  showEditModal,
  setShowEditModal,
  selectedID,
  setSelectedID,
  triggerUseEffect,
  setUseEffect,
}) => {
  const classes = useStyles();
  const [getCabins, setGetCabins] = useState([]);
  const [updatedDate, setUpdatedDate] = useState(new Date());
  const [updatedStartTime, setUpdatedStartTime] = useState(new Date());
  const [updatedEndTime, setUpdatedEndTime] = useState(new Date());
  const [dayClicked, setDayClicked] = useState(false);
  const [startTimeClicked, setStartTimeClicked] = useState(false);
  const [endTimeClicked, setEndTimeClicked] = useState(false);

  const UpdateReservationHandler = async (e) => {
    e.preventDefault();
    const data = { ...selectedID };

    try {
      const ax = await ax_updateBooking(data);
      if (ax.code === 200) {
        setShowEditModal(false);
        setUseEffect(true);
        toast.success(ax.data);
      } else {
        toast.error(ax.data);
      }
    } catch (e) {
      console.log("Error @UpdateReservationHandler:- ", e);
    }
  };

  // get Cabins from DB
  useEffect(() => {
    const ax_fetch = async () => {
      try {
        const ax = await ax_getCabins();
        if (ax.code === 200) {
          setGetCabins(ax.data.reverse());
          setUseEffect(true);
        }
      } catch (e) {
        console.log("Error While GET(ting) Sub Categories", e);
      }
    };
    ax_fetch();
  }, [triggerUseEffect]);

  return (
    <main className={classes.Page}>
      <main className={classes.Page_Content}>
        <main
          //  onSubmit={UpdateReservationHandler}
          className={classes.Input_Container}
        >
          {/* {JSON.stringify(selectedID.cabinName)}
         {JSON.stringify(format(selectedID.selectedDay, "dd/MM/yyyy"))} 
          {JSON.stringify(selectedID.day)}
          {JSON.stringify(selectedID.startTime)}
          {JSON.stringify(selectedID.endTime)} */}
          <section className={classes.Container_Two}>
            <div className="CabinName_Con">
              <label>Cabin Name</label>
              <select
                value={selectedID !== null ? selectedID.cabinName : ""}
                onChange={(e) => {
                  setSelectedID({
                    ...selectedID,
                    cabinName: e.target.value,
                  });
                }}
              >
                <option defaultValue id="default">
                  Choose a Cabin
                </option>
                {getCabins.map((cabin, index) => {
                  return (
                    <option key={cabin._id} value={cabin.cabinName}>
                      {cabin.cabinName}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="Day_Con">
              <label>Day</label>
              <DatePicker
                className={classes.OrginalDatePicker}
                open={dayClicked}
                onClose={() => setDayClicked(false)}
                disablePast={true}
                //  value={updatedDate}
                //  onChange={(date) => {
                //    setUpdatedDate(date);
                //  }}
                value={selectedID !== null ? selectedID.day : updatedDate}
                onChange={(date) => {
                  setSelectedID({
                    ...selectedID,
                    day: date,
                  });
                }}
                animateYearScrolling
              />
              <div
                className={`${classes.datePicker}`}
                // onClick={() => calendar(isEdit)}
                onClick={() => {
                  setDayClicked(true);
                }}
              >
                <div className="Calender_Con">
                  <div className="calenderIconCon">
                    <BsCalendarEvent className="calenderIcon" />
                  </div>
                </div>
                <div className="date_time_Con">
                  <p className="date">
                    {selectedID !== null
                      ? format(new Date(selectedID.day), "dd/MM/yyyy")
                      : "day"}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section className={classes.Container_Three}>
            <div className="StartTime_Con">
              <label>Start Time</label>
              <TimePicker
                open={startTimeClicked}
                onClose={() => setStartTimeClicked(false)}
                autoOk
                label="12 hours"
                //  value={updatedStartTime}
                //  onChange={(date) => {
                //    setUpdatedStartTime(date);
                //  }}
                value={selectedID !== null ? selectedID.startTime : "startTime"}
                onChange={(date) => {
                  setSelectedID({
                    ...selectedID,
                    startTime: date,
                  });
                }}
              />
              <div
                className={`${classes.datePicker}`}
                // onClick={() => calendar(isEdit)}
                onClick={() => {
                  setStartTimeClicked(true);
                }}
              >
                <div className="Calender_Con">
                  <div className="calenderIconCon">
                    <BiTime className="calenderIcon" />
                  </div>
                </div>
                <div className="date_time_Con">
                  <p className="date">
                    {/* {updatedStartTime.toLocaleTimeString()} */}
                    {/* {format(updatedStartTime, "hh:mm a")} */}
                    {selectedID !== null
                      ? format(new Date(selectedID.startTime), "hh:mm a")
                      : "startTime"}
                  </p>
                </div>
              </div>
            </div>
            <div className="EndTime_Con">
              <label>End Time</label>
              <TimePicker
                open={endTimeClicked}
                onClose={() => setEndTimeClicked(false)}
                autoOk
                label="12 hours"
                //  value={updatedEndTime}
                //  onChange={(date) => {
                //    setUpdatedEndTime(date);
                //  }}
                value={selectedID !== null ? selectedID.endTime : "endTime"}
                onChange={(date) => {
                  setSelectedID({
                    ...selectedID,
                    endTime: date,
                  });
                }}
              />
              <div
                className={`${classes.datePicker}`}
                // onClick={() => calendar(isEdit)}
                onClick={() => {
                  setEndTimeClicked(true);
                }}
              >
                <div className="Calender_Con">
                  <div className="calenderIconCon">
                    <BiTime className="calenderIcon" />
                  </div>
                </div>
                <div className="date_time_Con">
                  <p className="date">
                    {/* {updatedStartTime.toLocaleTimeString()} */}
                    {/* {format(updatedEndTime, "hh:mm a")} */}
                    {selectedID !== null
                      ? format(new Date(selectedID.endTime), "hh:mm a")
                      : "endTime"}
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section
            className={classes.Container_Six}
            onClick={UpdateReservationHandler}
          >
            <div className="Submit_Button">
              <div className="SubmitText_Con">
                <button type="submit">Update</button>
              </div>
            </div>
          </section>
        </main>
      </main>
    </main>
  );
};

export default Edit_Model;
